import React from 'react';
import { Text, Box } from '@chakra-ui/react';
import { orderHasAdminOverrideBug } from '../../utils/orderAdminOverride';
import CheckoutBugNoticeText from './CheckoutBugNoticeText';

const AdminOverrideBugNotice = ({
  order,
  variant = 'alert',
  fontSize = 'sm',
}) => {
  if (!orderHasAdminOverrideBug(order)) {
    return null;
  }

  if (variant === 'compact') {
    return (
      <Text fontSize={fontSize} color="gray.500" mt={2} lineHeight="tall">
        Vedi il riepilogo «Pagamenti da completare» per la situazione corretta e
        per saldare le settimane mancanti.
      </Text>
    );
  }

  return (
    <Box mb={variant === 'inline' ? 0 : 4}>
      <CheckoutBugNoticeText fontSize={fontSize} showPaymentHint={false} />
    </Box>
  );
};

export default AdminOverrideBugNotice;
